import React, { useEffect, useRef } from 'react';
import Type from 'prop-types';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { AddButton, ActivityIndicator, EmptyState } from 'components';
import { useTranslation } from 'hooks';
import { usePromises } from 'hooks/api/cascade';
import { useAbortRequest } from 'utils/useAbortRequest';
import { PromiseList } from './components';

const HistoryScreen = (props) => {
  const { listHeight } = props;
  const { pathname } = useLocation();
  const { entityId } = useParams();
  const history = useHistory();
  const { abortSignal } = useAbortRequest();
  const {
    status,
    isError,
    error,
    data: promises,
  } = usePromises(entityId, abortSignal);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const listRef = useRef(null);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePromiseCreate = () => {
    history.replace(`${pathname}/new`);
  };

  const renderPromises = () => {
    const hasPromises = promises.length !== 0;

    if (!hasPromises) {
      return <EmptyState title={t('noPromisesByCurrentCustomer')} />;
    }

    return (
      <PromiseList ref={listRef} listHeight={listHeight} promises={promises} />
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderPromises();
      default:
        return null;
    }
  };

  return (
    <>
      {renderFetchState()}

      <AddButton
        aria-label={t('createNewPromise')}
        onClick={handlePromiseCreate}
      />
    </>
  );
};

HistoryScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default HistoryScreen;
